import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { CreditCard2Back } from 'react-bootstrap-icons';


import React, { useState, useEffect } from 'react';
import UIStepBackButton from '../UIComponents/StepBackButton';
import FormCCPayment from './PaymentCC';
import FullNameBlock from '../blocks/NameBlock';
import AddressBlock from '../blocks/AddressBlock';
import LoadingAnimation from '../UIComponents/LoadingAnimation';

import GenericFormContainer from './FormContainer';
import { INTRFUser } from '../../hooks/Interfaces';
import { PostDataFetch, GetHeaders } from '../../hooks/DataFetch';

import { Truck, Signpost, Shop, Check2Square, Square } from 'react-bootstrap-icons';

import TimeWindowDropdown from '../blocks/DateDropdownTimeWindow';


import { useRef } from 'react';
import { IMaskInput } from 'react-imask';

interface CheckoutFormProps{
    user: INTRFUser;
    closefunc: (viewable: boolean) => void;
}

function CheckoutForm({user, closefunc}: CheckoutFormProps){
    let [firstname, setFirstname] = useState(""); //TODO
    let [lastname, setLastname] = useState(""); //TODO
    let [cardnum, setCardNum] = useState("4242424242424242");
    let [cardcvv, setCardCVV] = useState("123");
    let [cardexpmonth, setCardExpMonth] = useState(2); //Change Default Back
    let [cardexpyear, setCardExpYear] = useState(2028); // Change Default back
    let [mobilenumber, setMobileNumber] = useState(""); // Change Default back
    // use ref to get access to internal "masked = ref.current.maskRef"
    const ref = useRef(null);
    const inputRef = useRef(null);
    const phonemask = [{ mask: '(000) 000-0000' }, { mask: '(000) 000-0000' }]

    //TODO
    let [address, setAddress] = useState(user.address)
    let [addr1, setBAL1] = useState(address.address1);
    let [addr2, setBAL2] = useState(address.address2);
    let [addrcity, setBACity] = useState(address.city);
    let [addrstate, setBAState] = useState(address.state);
    let [addrzip, setBAZip] = useState(address.zip);

    


    /* UI Controls */
    let [ccpayment, setCCPayment] = useState(true);
    let [klarnapayment, setKlarnaPayment] = useState(false);

    let [paymentProcessed, setPaymentProcessed] = useState(false);
    let [waiting, setWaiting] = useState(false);
    let [errorMessage, setErrorMessage] = useState("");

    /* Delivery Options */
    let [deliverywindow, setDeliverWindow] = useState("");
    let [deliveryoption, setDeliverOption] = useState("store");
    let [delivery, setDelivery] = useState(false);
    let [curbside, setCurbSide] = useState(false);
    let [instore, setInstore] = useState(true);
    

    const ClearDeliveryOption = () =>{
        setDelivery(false);
        setCurbSide(false);
        setInstore(false);
    }
    const CheckDelivery = () => { ClearDeliveryOption();setDelivery(true);setDeliverOption("delivery"); }
    const CheckCurbSide = () => { ClearDeliveryOption();setCurbSide(true);setDeliverOption("curb"); }
    const CheckInStore = () => { ClearDeliveryOption();setInstore(true);setDeliverOption("store"); }

    /* form validators */
    const validDeliveryWindow = ():boolean => {
        if (deliverywindow === "") return false;
        return true;
    }
    const validMobileNumber = ():boolean => {
        const phoneregex = /^[0-9]{10}$/i;
        return phoneregex.test(mobilenumber)
    }

    const validalphasequence = (text: string):boolean => {
        const textregex = /^[a-zA-Z]{2,}$/i;
        textregex.test(text)
        return textregex.test(text)
    }

    const acceptableFormInputs = ():boolean => {
        if(!validDeliveryWindow()) return false;
        if(!validMobileNumber()) return false;
        if(!validalphasequence(firstname)) return false;
        if(!validalphasequence(lastname)) return false;
        return true
    }

    /* Component Init */
    useEffect(() => {
        setBAL1(address.address1)
        setBAL2(address.address2)
        setBACity(address.city)
        setBAState(address.state)
        setBAZip(address.zip)
        
    }, [address]);

    const PayWithCard = () => {
        setCCPayment(true)
        setKlarnaPayment(false)
    }
    const PayWithKlarna = () => {
        setCCPayment(false)
        setKlarnaPayment(true)
    }
    const submit = async (event: React.SubmitEvent) => {
            /* Don't reload page immediately so application can wait for API response */
        event.preventDefault();
        setErrorMessage("");
        setWaiting(true)

        const posturl = process.env.REACT_APP_API_URL + "/v1/commerce/checkout";
        const data = {
            firstname,lastname,
            cardnum,cardcvv,cardexpmonth,cardexpyear,
            addr1,addr2,addrcity,addrstate,addrzip,
            deliverywindow, deliveryoption, mobilenumber
        };
        let axiosConfig = GetHeaders();
        

        let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: data})
        console.log("Used the function...")
        console.log(response)

        //Successful response
        if (200 == response.status){
            console.log("success response.")
            setPaymentProcessed(true);
            /* Change to successful payment screen */
            /* Clear Inputs? */
            
        }else{
            console.log("fail response.")
            setErrorMessage(response.message);
        }
        //remove saved session id
        //remove csrf token
        
        setWaiting(false)
    };

    return (
        <> 
            <Row className="">
                <hr></hr>
                <Col className="p-0 text-start" xs={{ span: 2}} >
                    <UIStepBackButton closefunc={closefunc} />
                </Col>
                <Col>
                    <p className="text-font-body text-font-size-large text-start">Checkout</p>
                </Col>
            </Row>

            { waiting &&
            <>
                <Row className="">
                    <Col className="text-white square-image-block text-white">
                        <LoadingAnimation />
                    </Col>
                </Row>
            </>
            }

            { !waiting && paymentProcessed &&
            <>
                <Row className="">
                    <Col className="bg-success text-white square-image-block">
                        Payment Accepted!
                    </Col>
                </Row>
            </>
            }

            { !waiting &&  !paymentProcessed &&
            <>
            
            <Row className="">
                <Col className="bg-white py-3">
                    <form onSubmit={submit}>
                        { errorMessage && 
                            <Row className="p-2">
                                <Col className="bg-danger text-white"><p>{errorMessage}</p></Col>
                            </Row>
                        }


                        <Row>
                            <FullNameBlock formPrefix="name" outputFirstName={setFirstname} outputMiddleName={(string) => {}} outputLastName={setLastname} />
                        </Row>
                        <Row>
                            <Col className="py-5">
                                <div className="brand-tertiary-color-border">
                                    <p className="text-start text-font-body text-font-size-small">Required for updates & communication</p>
                                    <IMaskInput
                                        id="phone"
                                        mask={phonemask}
                                        className="border-0 input-fill no-generic-input-styles"
                                        type="tel"
                                        radix="."
                                        value={mobilenumber}
                                        aria-describedby='telhelp'
                                        unmask={true} // true|false|'typed'
                                        ref={ref}
                                        inputRef={inputRef}  // access to nested input
                                        // DO NOT USE onChange TO HANDLE CHANGES!
                                        // USE onAccept INSTEAD
                                        onAccept={
                                            // depending on prop above first argument is
                                            // `value` if `unmask=false`,
                                            // `unmaskedValue` if `unmask=true`,
                                            // `typedValue` if `unmask='typed'`
                                            //(value, mask) => console.log(value)
                                            (value, mask) => setMobileNumber(value)
                                        }
                                        // ...and more mask props in a guide

                                        // input props also available
                                        placeholder='Mobile Number (Texts) *'
                                    />
                                </div>
                                
                            </Col>
                        </Row>

                        <Row className="py-4">
                            <Col xs={{span: 12}}>
                                <p className="text-start text-font-body text-font-size-large">Billing Address</p>
                            </Col>
                            <AddressBlock formPrefix='checkout' address={address} updateAddress={setAddress}/>
                        </Row>


                        <Row>
                            <TimeWindowDropdown outputTimeWindowString={setDeliverWindow}/>
                        </Row>

                        <Row>


                            <Col className="square-image-block" onClick={(e) => CheckInStore()}>
                                <div className={ instore ? "brand-tertiary-color brand-primary-font-color py-3" : "brand-primary-color brand-tertiary-font-color py-3"}>
                                    <p><Shop size={38} /></p>
                                    <p>In Store { instore ? <Check2Square size={12} /> : <Square size={12} /> }</p>

                                </div>
                            </Col>


                            <Col className="square-image-block" onClick={(e) => CheckCurbSide()}>
                                <div className={ curbside ? "brand-tertiary-color brand-primary-font-color py-3" : "brand-primary-color brand-tertiary-font-color py-3"}>
                                    <p><Signpost size={38} /></p>
                                    <p>Curbside { curbside ? <Check2Square size={12} /> : <Square size={12} /> }</p>
                                </div>
                            </Col>


                            <Col className="square-image-block" onClick={(e) => CheckDelivery()}>
                                <div className={ delivery ? "brand-tertiary-color brand-primary-font-color py-3" : "brand-primary-color brand-tertiary-font-color py-3"}>
                                    <p><Truck size={38} /></p>
                                    <p>Delivery { delivery ? <Check2Square size={12} /> : <Square size={12} /> }</p>
                                </div>
                            </Col>


                        </Row>
                        <Row>
                            <Col>
                                <p className="text-font-body text-font-size-medium text-start">Payment Method</p>
                            </Col>
                        </Row>
                        <Row className="p-1">
                            <Container className="brand-primary-color-border">
                                <Row onClick={PayWithCard}>
                                    <Col xs={{span: 2}}>
                                        <CreditCard2Back size={24}/> 
                                    </Col>
                                    <Col xs={{span: 9}}>
                                        <p className="text-font-body text-font-size-small text-start">Credit Card</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <p>Coming soon.</p>
                                    { ccpayment && false &&
                                        <FormCCPayment
                                        updateCCNum={setCardNum} 
                                        updateCVV={setCardCVV} 
                                        updateExpMon={setCardExpMonth} 
                                        updateExpYear={setCardExpYear} />
                                    }
                                </Row>
                            </Container>
                        </Row>
                        <Row className="p-1">
                            <Container className="brand-primary-color-border">
                                <Row onClick={PayWithKlarna}>
                                    <Col xs={{span: 2}}>
                                        <img src="/klarna.png" className="w-100" /> 
                                    </Col>
                                    <Col xs={{span: 9}}>
                                        <p className="text-font-body text-font-size-small text-start">Klarna Coming Soon</p>
                                    </Col>
                                </Row>
                                <Row>
                                    { klarnapayment && 
                                        <p>Coming soon.</p>
                                    }
                                </Row>
                            </Container>
                        </Row>
                        


                        
                        
                    <button type="submit" className="btn brand-btn-secondary-color  w-100" disabled={!acceptableFormInputs()}>Purchase</button>
                    </form>
                </Col>
            </Row>
            </>
            }

            
            
        </>
    )
}
export default CheckoutForm;